/* Publish by EComposer at 2024-06-10 21:02:23*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-eicf9k14m38"]=  window.__ectimmers["ecom-eicf9k14m38"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-eicf9k14m38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eicf9k14m38', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}